import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import {
  IBriefInfluencerV2,
  IDataFieldValue,
} from "@shared/lib/types/briefInfluencerV2";
import {
  BRIEF_DATA_FIELDS_QUERY_KEY,
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
} from "../constants";
import { BriefService } from "../services/brief.service";

interface IEditDataFieldV2DataRequest {
  briefInfluencerId: string;
  dataField: { [key: string]: IDataFieldValue };
  handleSuccess: (id: string, briefInfluencer: IBriefInfluencerV2) => void;
}

export function useEditDataFieldV2Data(briefId: string) {
  const {
    mutate: editDataField,
    isLoading: isEditing,
    isSuccess: isEdited,
    variables,
  } = useMutation({
    mutationFn: (data: IEditDataFieldV2DataRequest) =>
      BriefService.editDataFieldV2Data(
        data.briefInfluencerId,
        data.dataField
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    // options: {
    //   skipInvalidation: true,
    // },
    options: {},
    onSuccess: (c, data, { handleSuccess }) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_DATA_FIELDS_QUERY_KEY, briefId],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, briefId],
        refetchType: "all", // Refetch all matching queries including inactive pages
      });

      handleSuccess?.(data.data._id, data.data);
    },
  });

  return {
    editDataField,
    isEditing,
    isEdited,
    editDataFieldVariables: variables,
  };
}
